
<template>
  <div class="headder" v-show="$route.name=='postEdit'?false:true">
    <div class="head-cont clear">
      <div class="logo-lk fl">
        <a :href="baseUrl" class="logo-c">
          <img v-if="logoUrl" :src="BASE_URL + logoUrl" alt="logo">
          <img v-else src="../../../../public/logo.png" alt="logo">
        </a>
        <a v-if="logoTxt" :href="baseUrl" class="logo-txt">{{logoTxt}}</a>
        <i>·</i>
        <router-link to="/group" class="link-home">圈组</router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      logoUrl: sessionStorage.getItem('logoUrl'),
      logoTxt: sessionStorage.getItem('logoTxt')
    }
  },
  // watch: {
  //     $route: {
  //       handler(newName, oldName) {
  //         // console.log(this.BASE_URL);
  //       },
  //       deep: true
  //   },
  // },
  // created() {
  // 		this.getLogo();
  // },
  // methods: {
  //     getLogo(){
  // 			let success = (res=>{
  //       	this.logo_url = res.data[0].app_logo;
  //     	})
  // 			this.$ajax({
  // 				url: 'api/system/get_logo',
  // 				method: 'get',
  // 				params: {},
  // 				func: {success: success}
  // 			})
  //     }
  // }
}
</script>

<style lang="scss">
.headder {
  background: #fff;
  height: 80px;
  box-shadow: 0 2px 4px 0 rgba(195, 195, 195, 0.3);
}
.head-cont {
  padding: 15px 25px 0 25px;
}
.logo-lk {
  > a {
    line-height: 40px;
  }
  > i {
    margin: 0 5px;
    font-weight: bold;
  }
  .link-home {
    font-size: 16px;
    color: #000000;
    letter-spacing: 2px;
  }
}

.train-test {
  button {
    background: #E62125;
    border-radius: 3px;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    padding: 0;
  }
  > a,
  > span {
    display: inline-block;
    vertical-align: top;
    line-height: 36px;
    color: #338efc;
    margin-right: 30px;
    cursor: pointer;
  }
}
</style>